






















import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  props: {
    name: {
      type: String,
      default: '',
    },
    value: {
      type: Boolean,
      default: false,
    },
  },
})
